export const registerOnMessage = (callback,type) => {


}

export const requestPermission = () => {

}

export const registerOnToken = (callback) => {    
   
}

export const getOnToken = () => {
   
}

export const subscribeToTopic = () => {

}

export const unsubscribeToTopic = () => {

}
export const FingerPrintIsAvailable = (callbackSucess, callbackError) => {}
export const FingerPrintShow = (callbackSucess, callbackError) => {}
export const captureImage = (onSuccess, onFail) => {
}
export const captureImageHighDefinition = (onSuccess, onFail) => {
}

export const getImageBase64 = imageURI => {
}
